const firebaseConfig = {
    apiKey: "AIzaSyCBZJHFQW2K4qehTjWdfDCqR3m664ZM0k8",
    authDomain: "hot-onion-restaurant-suvo176.firebaseapp.com",
    databaseURL: "https://hot-onion-restaurant-suvo176.firebaseio.com",
    projectId: "hot-onion-restaurant-suvo176",
    storageBucket: "hot-onion-restaurant-suvo176.appspot.com",
    messagingSenderId: "220521437361",
    appId: "1:220521437361:web:e8c5741f2f7c28d61b6a90"
  };

  export default firebaseConfig;